<template>
    <div>
        <header>
            <div class="header-container">
                <p class="header-title">前端规范</p>
            </div>
        </header>
        <div class="main">
            <left></left>
            <div class="right">
                <router-view></router-view>
            </div>
        </div>
        <!-- <footer>
            <ul>
                <li>参考网站：</li>
                <li><a target="_black" href="https://codeguide.bootcss.com/#html-doctype">编码规范 by @mdo</a></li>
                <li><a target="_black" href="https://www.runoob.com/">菜鸟教程</a></li>
                <li><a target="_black" href="https://developer.mozilla.org/zh-CN/docs/Web">MDN</a></li>
            </ul>
        </footer> -->
    </div>
</template>

<script>
import Left from './left.vue'
export default {
    name: 'home',
    components: { Left }
}
</script>

<style lang="scss" scoped>
header{
    height: var(--header-height);
    .header-container{
        height: var(--header-height);
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        border-bottom: 1px solid #dcdfe6;
        z-index: 2000;
        background-image: radial-gradient(transparent 1px, #fff 1px);
        background-size: 4px 4px;
        backdrop-filter: saturate(50%) blur(4px);
        .header-title{
            max-width: 1400px;
            min-width: 1000px;
            margin: 0 auto;
            line-height: var(--header-height);
            font-size: 22px;
            font-weight: bold;
        }
    }
}
.main{
    max-width: 1400px;
    min-width: 1000px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    position: relative;
    align-items: flex-start;
    .right{
        padding-top: 50px;
        padding-bottom: 100px;
        flex-grow: 1;
        background-color: #fff;
        overflow: auto;
    }
}
footer{
    padding: 20px 0 50px;
    min-width: 1000px;
    ul{
        list-style: none;
        text-align: center;
        li{
            line-height: normal;
            font-size: 18px;
            a{
                color: #1c7ed6;
            }
        }
    }
}
</style>